export default {
    global: {
        close : 'Schließen',
        save : 'Speichern',
        continue : 'Fortsetzen',
        confirmAndSend : 'Bestätigen und senden',
        mandatory_field : 'Dieses Feld wird benötigt',
        cancel : 'Stornieren',
        ok : 'Ok',
        yes : 'Ja',
        no : 'Nein',
        post_success : 'Daten gut gesendet'
    },
    menu:{
        main_menu : 'Hauptmenü',
        lmra : 'Öffnen/Schließen LMRA',
        report_incident: 'Einen Vorfall melden',
        report_near_incident : 'Melden Sie einen nahen Vorfall',
        risk_analysis : 'Risikoanalyse',
        corona_analysis : 'Corona-Analyse',
        scan_qr : "TAG / QR-CODE scannen",
        process_issue : "Prozessproblem melden",
        checklist : "heckliste anzeigen",
        log_in: "Einloggen",
        log_out : "Ausloggen",
        emergency_numbers : "Notrufnummern"
    },
    default_lrma: {
        what_label : 'Verstehe ich, was ich zu tun habe?',
        how_label : 'Weiß ich, wie es geht?',
        risks_label : 'Erkenne ich die Gefahren und Risiken?',
        control_label : 'Kann ich es kontrollieren?',
        default_pbm_label : 'Habe ich die richtige PSA?',
        default_pbm_question : 'Habe ich die richtige PSA?|1',
        lmra_job_state_positive : 'Ok, um mit der Arbeit zu beginnen, werden wir die LMRA überprüfen, wenn Änderungen auftreten',
        lmra_job_state_negative : 'Wir beginnen noch nicht mit der Arbeit.',
    },
    static_three_state_lmra : {
        getting_data_title : "Die neueste Version wird heruntergeladen.",
        could_not_load_newest_list_title : 'Achtung!',
        could_not_load_newest_list : 'Beim Abrufen der neuesten Liste ist ein Fehler aufgetreten. Eine ältere gespeicherte Version der Liste wird angezeigt, damit Sie fortfahren können. Wenn dieses Problem weiterhin besteht, informieren Sie am besten eine verantwortliche Person.',
    },
    private_location : {
        title : 'Sind Sie an einem privaten Ort?',
        body : 'Private Standorte sind Standorte außerhalb arbeitsbezogener Standorte.'
    },
    remarks:{
        remarksDialogTitle : 'Bemerkungen?',
        remarksDialogPlaceholder: 'Geben Sie hier Ihre Anmerkungen ein',
    },
    start_stop_screen :{
        start_work_btn : "beginne zu arbeiten",
        stop_work_btn : "aufhören zu arbeiten",
    },
    work_report : {
        title : "Arbeitsbericht",
        placeholder : "Geben Sie hier Ihren Arbeitsbericht ein",
        skip_work_report : "Überspringen"
    },
    incident_report: {
        title: "Vorfall melden",
        placeholder : "Was ist passiert?",
    },
    oeps_report:{
        title: "In der Nähe des Vorfalls melden",
        placeholders : {
            machine : 'Welche Maschine?',
            who : 'Wer war beteiligt?',
            what : 'Was ist passiert?',
            how : 'Wie ist das passiert / wie ist das passiert?',
            stop_card : 'Wählen Sie Stopcard',
            location: 'Ort auswählen',
            department: 'Abteilung auswählen'
        },
        external_employee : 'Ist ein externer Mitarbeiter',
        when_text_label : 'Wann ist das passiert?',
        change_date_time_btn : 'Datum / Uhrzeit ändern'
    },
    risk_analysis:{
        title: {
            risk_default : "Risikoanalyse",
            risk_default_sub_title: '',
            corona: "Corona-Analyse",
            corona_sub_title: 'Geben Sie unten Ihre Arbeitsbedingungen an und finden Sie heraus, wie Sie sicher arbeiten können.'
        },
        lists :{
            risk_default : {
                gravity :{
                    label: 'Schwere' ,
                    gravity_01 : 'geringfügig, Verletzung ohne Fehlzeiten',
                    gravity_02 : 'wichtig, Verletzung und Fehlzeiten',
                    gravity_07 : 'schwere, dauerhafte Behinderung / chronische Erkrankungen mit (teilweiser) Arbeitsunfähigkeit',
                    gravity_15 : 'sehr ernst, 1 Toter (langfristig akut)',
                    gravity_40 : 'Katastrophe, mehrere Todesfälle'
                },
                probability :{
                    label: 'Wahrscheinlichkeit' ,
                    probability_0_1 : 'fast unmöglich vorstellbar',
                    probability_0_2 : 'praktisch unmöglich',
                    probability_0_5 : 'vorstellbar, aber unwahrscheinlich',
                    probability_01 : 'unwahrscheinlich, Grenzfall',
                    probability_03 : 'ungewöhnlich, aber möglich',
                    probability_06 : 'gut möglich',
                    probability_10 : 'erwartet'
                },
                exposure : {
                    label : 'Exposition',
                    exposure_0_5 : 'sehr selten (1x pro Jahr)',
                    exposure_01 : 'selten (jährlich)',
                    exposure_02 : 'manchmal (monatlich)',
                    exposure_03 : 'gelegentlich (wöchentlich)',
                    exposure_06 : 'regelmäßig (täglich)',
                    exposure_10 : 'ständig',
                },
            },
            corona : {
                distance :{
                    label: 'Erwartete Entfernung zwischen mir und anderen:' ,
                    distance_01 : 'A > 8 m',
                    distance_02 : '6 m < A < 8 m',
                    distance_07 : '2 m < A < 6 m',
                    distance_15 : '1,5 m < A < 2 m',
                    distance_40 : '1 m < A < 1,5 m',
                    distance_100 : 'A < 1 m'
                },
                probability :{
                    label: 'Ich bemerke, dass andere ...' ,
                    probability_0_1 : 'Tragen Sie eine FFP2-Maske + Schutzbrille + Schutzkleidung',
                    probability_0_2 : 'Tragen Sie eine FFP2-Maske + Brille',
                    probability_0_5 : 'Tragen Sie eine Maske oder einen Gesichtsschutz',
                    probability_01 : 'Beachten Sie auf jeden Fall die Corona-Richtlinien',
                    probability_03 : 'Vielleicht respektieren Sie die Corona-Richtlinien',
                    probability_06 : 'Gegen einige Corona-Richtlinien verstoßen',
                    probability_10 : 'Mehrere Corona-Richtlinien verletzt'
                },
                exposure : {
                    label : 'Chance auf engen Kontakt als erwartet:',
                    exposure_0_5 : 'Sehr unwahrscheinlich',
                    exposure_01 : 'Wenn mehrere Dinge schief gehen',
                    exposure_02 : 'Ungewöhnlich, wenn bestimmte Dinge schief gehen',
                    exposure_03 : 'Möglicherweise sind die Chancen nicht so groß',
                    exposure_06 : 'Möglicherweise, vernünftige Chance',
                    exposure_10 : 'Mit ziemlicher Sicherheit zu erwarten',
                },
            },
        },
        results: {
            risk_default : {
                kinneyCode1 : 'keiner',
                kinneyCode2 : 'Aufmerksamkeit erforderlich',
                kinneyCode3 : 'erforderliche Maßnahmen können geplant werden',
                kinneyCode4 : 'sofortige Verbesserung',
                kinneyCode5 : 'aufhören zu arbeiten'
            },
            corona :{
                kinneyCode1 : 'Akzeptables Risiko: Keine zusätzlichen Schutzmaßnahmen erforderlich',
                kinneyCode2 : 'Mögliches Risiko: Benötigt Aufmerksamkeit',
                kinneyCode3 : 'Hauptrisiko: Schutzmaßnahmen ergreifen',
                kinneyCode4 : 'Hohes Risiko: Ergreifen Sie erhöhte Schutzmaßnahmen',
                kinneyCode5 : 'Sehr hohes Risiko: Versuchen Sie, die Aktivität anzupassen. Wenn dies nicht möglich ist, ergreifen Sie maximale Schutzmaßnahmen'
            },
        },
        supportive_texts : {
            risk_default : {
                supportiveText1 : '',
                supportiveText2 : '',
                supportiveText3 : '',
                supportiveText4 : '',
                supportiveText5 : ''
            },
            corona : {
                supportiveText1 : 'Ich kenne und respektiere die Corona-Richtlinien, die in meiner Arbeitsumgebung gelten.',
                supportiveText2 : 'Ich kenne und respektiere die geltenden Corona-Richtlinien. Ich fordere die Menschen in meinem Arbeitsumfeld ausdrücklich auf, auch die Corona-Richtlinien einzuhalten. Es sind keine weiteren zusätzlichen Schutzmaßnahmen erforderlich.',
                supportiveText3 : 'Ich war oder desinfizierte Hände zu Beginn und am Ende der Aktivität. Ich trage einen Gesichtsschutz oder eine geeignete Mundmaske in Kombination mit einer (Sicherheits-) Brille. Die Menschen in meiner Arbeitsumgebung müssen mindestens auch einen Gesichtsschutz oder eine Nasenmaske tragen (vorzugsweise zusammen mit einer Schutzbrille). Ich weiß, wie man diese kollektiven Schutzausrüstungen richtig einsetzt und in der Praxis anwendet. Ich kenne und respektiere die geltenden Corona-Richtlinien und fordere die Personen in meinem Arbeitsumfeld ausdrücklich auf, auch die Corona-Richtlinien einzuhalten.',
                supportiveText4 : 'Ich war oder desinfizierte Hände zu Beginn und am Ende der Aktivität und nach jeder unsicheren Berührung. Ich trage eine schützende Mundnasenmaske (vorzugsweise eine FFP2-Atemschutzmaske) in Kombination mit einem Gesichtsschutz oder einer Schutzbrille. Ich weiß, wie man diese persönliche Schutzausrüstung (PSA) richtig verwendet und in der Praxis anwendet. Ich kenne die Corona-Richtlinien, die im Arbeitsumfeld gelten, und respektiere diese Corona-Richtlinien natürlich weiterhin. Ich fordere die Menschen in meinem Arbeitsumfeld auf, auch die erforderlichen Sicherheitsmaßnahmen zu ergreifen und die Corona-Richtlinien zu beachten.',
                supportiveText5 : 'Ich überlege zunächst, ob die Tätigkeit ohne direkten Kontakt mit anderen Personen auf andere Weise durchgeführt werden kann. Ist dies nicht möglich, werde ich alle möglichen Sicherheitsmaßnahmen ergreifen. Ich war oder desinfizierte Hände zu Beginn und am Ende der Aktivität. Ich trage Schutzhandschuhe. Ich trage eine Atemschutzmaske (mindestens FFP2) in Kombination mit einem Gesichtsschutz oder einer Schutzbrille und Schutzkleidung. Ich weiß, wie man diese persönliche Schutzausrüstung (PSA) richtig verwendet und in der Praxis anwendet. Ich kenne die Corona-Richtlinien, die im Arbeitsumfeld gelten, und respektiere diese Corona-Richtlinien natürlich weiterhin. Ich fordere die Menschen in meinem Arbeitsumfeld auf, auch die erforderlichen Sicherheitsmaßnahmen zu ergreifen und die Corona-Richtlinien sorgfältig zu beachten.'
            }
        },
        leave_warning : {
            risk_default : {
                title : 'Achtung!',
                body : 'Sie schließen dieses Fenster, ohne den aktuellen Risikoanalysebericht zu senden. Sind Sie sicher, dass Sie die Seite verlassen möchten?'
            },
            corona : {
                title : 'Achtung!',
                body : 'Sie schließen dieses Fenster, ohne den aktuellen Corona-Analysebericht zu senden. Sind Sie sicher, dass Sie die Seite verlassen möchten?'
            }
        },
        report_title : 'Analysebericht',
        placeholder_report : 'Beschreiben / klären Sie die Situation'
    },
    process_issue:{
        title: "Ein Prozessproblem melden",
        placeholders :{
            issue_type_select: 'Wählen Sie den Problemtyp',
            failure_detail: 'Wählen Sie das Problemdetail aus',
            who : 'Wer war beteiligt?',
            description : 'Beschreibe das Problem',
            cnf : 'CNF?',
            comment : 'Zusätzliche Anmerkungen / Kommentare (optional)',
            other : 'Andere'
        }
    },
    checklist: {
        getting_data_title : "Die neueste Checkliste wird gesammelt."
    },
    data_transfer : {
        post_busy : 'Bitte warten Sie, die Daten werden gesendet.',
        post_success : 'Daten gut gesendet.'
    },
    gdpr_disclaimer : {
        title: 'GDPR-Vorschlag:',
        body: 'Beim Einreichen eines Elements der lmra-first-Anwendung werden die folgenden Elemente in der Datenbank gespeichert: aktueller Standort (GPS - Koordinaten (nach Bestätigung)) und genaue Uhrzeit (und nur zu diesem Zeitpunkt). Keiner dieser Artikel wird an andere Parteien oder Organisationen verkauft. Die gespeicherten Daten werden nur in der Reihenfolge des Projekts und der damit verbundenen Arbeitsbedingungen verwendet',
        accept_btn : 'Ich nehme an',
        decline_btn : 'Verlasse die App'
    },
    data_notice: {
        button_text: 'Was passiert mit diesen Informationen?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings : {
        alert_cn_pid_nf_title : 'Hoppla, du hast etwas vergessen:',
        alert_cn_pid_nf_body : 'Kundenname und / oder Projekt-ID nicht ausgefüllt, bitte Werte überprüfen',
        client_select_placeholder : 'Wählen Sie einen Client aus',
        project_select_placeholder : 'Wählen Sie ein Projekt aus',
        client_not_in_list_label : 'Kunde nicht in der Liste',
        project_not_in_list_label : 'Projekt nicht in der Liste',
        client_name : 'Kundenname',
        project_id : 'Projekt-ID',
        project_distance : 'Projektentfernung',
        project_shift : 'Projekt shift',
        user_initials : 'Deine Initialen',
        project_tag_code_label : 'Projekt TAG-Code',
        warning : {
            intro : 'Sie verwenden jetzt die manuelle Eingabe für',
            reason_server :'weil Serverdaten nicht geladen werden konnten!',
            reason_client_not_listed :'weil der Kunde nicht in der aktuellen Liste war!',
            reason_project_not_listed :'weil das Projekt nicht in der aktuellen Liste war!',
            dbl_check : 'Überprüfen Sie alle Ihre Werte, bevor Sie speichern!',
            admin_msg : 'Wenn diese Meldung weiterhin angezeigt wird, wenden Sie sich an Ihren Administrator und melden Sie dies!'
        },
        input_errors : {
            no_client_selected : 'Bitte wählen Sie einen Kunden aus',
            no_project_selected : 'Bitte wählen Sie ein Projekt aus',
        },
        loading_cap : 'Laden von Daten vom Server'
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Kamera-Stream wird geladen ...',
            default_error_button_test : 'Beenden'
        },
        overlay_view: {
            title : 'Scan TAG - Code',
            info_manual : 'Haben Sie Probleme beim Scannen? Manuelle Eingabe verwenden ',
            manual_btn : 'Manuelle Eingabe aktivieren.',
            errors : {
                invalid_tag_title : 'Ungültiger TAG-CODE',
                invalid_tag_body : 'Der Code, den Sie gescannt haben, ist kein gültiger TAG-CODE, scannen Sie einen gültigen TAG-CODE oder wechseln Sie zur manuellen Eingabe.',
                error_btn_txt : 'Manuelle Eingabe aktivieren'
            }
        }
    },
    errors:{
        checklistNotLoaded : 'Beim Abrufen der Liste ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        EmergencyNumbersOverviewNotLoaded : 'Beim Abrufen der Liste ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        missing_critical_resource_title : 'Fehler beim Laden der Daten:',
        missing_critical_resource : 'In der Anwendung fehlt eine Ressource. Melden Sie den folgenden Code dem Administrator.',
        app_corrupt : 'Es scheint, dass die Anwendungskonfiguration beschädigt ist. Bitte wenden Sie sich an Ihren Administrator.',
        data_save_failed : 'Die Daten konnten nicht gesendet werden, versuchen Sie es später erneut ...',
        camera: {
            NotAllowedError : 'FEHLER: Sie müssen die Erlaubnis für den Kamerazugriff erteilen',
            NotFoundError : 'FEHLER: Keine Kamera auf diesem Gerät',
            NotSupportedError : 'FEHLER: Sicherer Kontext erforderlich (HTTPS, localhost)',
            NotReadableError : 'FEHLER: Wird die Kamera bereits verwendet?',
            OverconstrainedError : 'FEHLER: Installierte Kameras sind nicht geeignet',
            StreamApiNotSupportedError : 'FEHLER: Die Stream-API wird in diesem Browser nicht unterstützt',
        },
        no_internet : 'Ups ... Sie sind offline, überprüfen Sie Ihre Internetverbindung!',
        input_validation : {
            char_limit : 'Es sind maximal %n Zeichen zulässig'
        },
        auth0 :{
            unverified_email : {
                error: 'Fehler: E-Mail-Adresse ist nicht verifiziert! Überprüfe deine Emails!',
                info : 'Um Zugriff auf diese Anwendung zu erhalten, <b>müssen Sie Ihre E-Mail-Adresse bestätigen</b>.<br/><br/>Sie erhalten in Kürze <b>eine E-Mail</b> <b >von |SENDER| </b><br/><br/><i>Um Ihre E-Mail-Adresse zu bestätigen. Folgen Sie den Anweisungen in der E-Mail</i>'
            }
        }
    },
    noDataText: "Keine Daten verfügbar ...",
    defaultDynamicQuestion : '{"dynamic_questions":[{"id":null,"question":"Habe ich die richtige PSA?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'E-Mail',
        passwordLabel : 'Passwort',
        rememberMeLabel : "Erinnere dich an mich",
        logInBtn: "Anmelden",
        logOutBtn: "Abmelden",
        verifyMFABtn : "Bestätigen",
        errorPopupTitle : "Fehler",
        confirmIdentify : "Immer noch du?",
        errors :{
            required : "Erforderlich",
            invalidEmail : "Ungültige E-Mail",
            unknownError : "Ein unbekannter Fehler ist aufgetreten"
        },
        registerNewAccountBtn : "Erstelle ein neues Konto."
    },
    lmraComponent : {
        loadingProjectData : 'Ihr LMRA-Formular wird vorbereitet, bitte warten',
        errors : {
            unknownError : "Ein unbekannter Fehler ist aufgetreten",
            noListDataFound : "Fehler: KEINE LISTENDATEN GEFUNDEN!! AUF STANDARD-LMRA ZURÜCKSETZEN",
            noDefaultListFound: 'Keine Standardliste verfügbar! Verwenden von STANDARD-LMRA!',
        }
    },
    customLmraLists : {
        buildingListTitle : "Das Erstellen Ihres LMRA-Formulars sollte nicht zu lange dauern.",
        criticalErrorTitle: 'Fehler:',
        criticalErrorBody: "Beim Erstellen Ihres LMRA-Formulars ist etwas schief gelaufen! Wir werden jetzt die Standard-LMRA laden! Bitte teilen Sie Ihrem Vorgesetzten den folgenden Fehlercode mit: ",
    },
    workSessions :{
        global : {
            expiredLabel : "Abgelaufen"
        },
        resumeSessionDialog : {
            titleActiveSession : "Aktive Sitzung gefunden",
            titleActiveSessionExpired : "(Abgelaufen) Aktive Sitzung gefunden",
        },
        workSessionServiceNaDialog :{
            title : 'WORKSESSION SERVICE NICHT VERFÜGBAR',
            body : 'Leider können wir nicht feststellen, ob Sie eine offene Sitzung haben<br/><br/>' +
                '<b>LMRA-Modul ist gesperrt: Sie können eine Sitzung nicht starten oder schließen. </b><br/> Sie können jedoch weiterhin Vorfallberichte (außerhalb der Sitzung) senden<br/>' +
                'Sie erhalten eine Benachrichtigung, wenn der Sitzungsdienst verfügbar ist<br/><br/>' +
                'Wenn dieser Fehler weiterhin besteht, benachrichtigen Sie bitte Ihren Administrator..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Entschuldigung: <b>Das LMRA-Modul ist derzeit gesperrt: Sie können eine Sitzung nicht starten oder schließen. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'Serverantwort enthält keine Sitzungsdaten',
                    could_not_save_session : 'Sitzungsdaten konnten nicht lokal gespeichert werden...',
                    invalid_session_data : 'Sitzungsdaten ungültig, Daten könnten beschädigt sein'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "Ein unbekannter Fehler ist aufgetreten",
            notFound : "Kein Gruppencode gefunden."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Standard-Notrufnummer",
        getting_data_title: "Neueste Zahlen abrufen"
    }
}